import { render, staticRenderFns } from "./EnvioOpcionCard.vue?vue&type=template&id=66efe376&scoped=true&"
import script from "./EnvioOpcionCard.vue?vue&type=script&lang=js&"
export * from "./EnvioOpcionCard.vue?vue&type=script&lang=js&"
import style0 from "./EnvioOpcionCard.vue?vue&type=style&index=0&id=66efe376&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66efe376",
  null
  
)

export default component.exports